import { useMutation } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const fetchUserData = async (user_id) => {
  if (!user_id) return;

  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const params = {
    search_by: 'user_id',
    search_str: user_id,
  };

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.SEARCH_USER,
    params
  );
  return response?.data?.data ?? null;
};

export const useGetUserData = () => {
  return useMutation({
    mutationKey: ['SEARCH_USER'],
    mutationFn: fetchUserData,
  });
};
